// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__XQSWT","overflowing":"ReadFullNote_overflowing__1JwP-"};